export const AUTH_FAILED = 'AUTH_FAILED';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_MESSAGE = 'AUTH_MESSAGE';
export const GET_AUTH = 'GET_AUTH';
export const LOG_OUT_AUTH = 'LOG_OUT_AUTH';
export const ALL_USER_SEARCH = 'ALL_USER_SEARCH';